export default "__VITE_ASSET__0ZM5iTcv__"